import { theme } from "../theme";

export const PayrollStyle = () => ({
    containerPayroll: {
        color: theme.palette.primary.black,
        padding: '0 48px',
        height: '80vh',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
        [theme.breakpoints.down('md')]: {
          padding: '0px',
        },
    },
    breadcrumbs: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        margin: '0 0 30px 0',
    },
    breadcrumbsText:{
        fontFamily: 'Inter',
        fontWeight: 500,
        fontSize: '12px',
        color: theme.palette.secondary.mainGray,
        textDecoration: "none",
    },
    separatorBreadcrumbs:{
        color: theme.palette.secondary.mediumGray,
        width: '18px'
    },
    breadcrumbsTextSelected:{
        fontFamily: 'Inter',
        fontWeight: 700,
        fontSize: '12px',
        color: theme.palette.primary.black,
    },
    btnFilter:{
        backgroundColor: theme.palette.primary.white,
        color: theme.palette.primary.black,
        display: 'flex',
        height: 32,
        border: 'none',
        textTransform: 'none',
        boxShadow: '0px 2px 2px 0px rgb(36 35 35 / 15%)',
        fontFamily: 'Inter',
        fontWeight: 500,
        fontSize: '12px',
        '&:hover':{
            backgroundColor: theme.palette.primary.white,
        }
    },
    iconBtnFilter:{
        color: theme.payroll.greenMain,
        width: '15px'
    },
    title: {
        fontSize: { xs: "20px", md: "28px" },
        fontWeight: "bold" 
    },
    containerToolbar:{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
            gap: '20px'
        },
    },
    contSearchAndExcel: {
        display: 'flex',
        gap: '20px',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            gap: '20px'
        },
    },
    btnExcel:{
        display: 'flex',
        height: 32,
        border: 'none',
        backgroundColor: theme.payroll.greenLight,
        color: theme.payroll.greenMain,
        textTransform: 'none',
        fontSize: '12px',
        fontWeight: 500,
        fontFamily: 'Inter',
        boxShadow: 'none',
        '&:hover':{
            backgroundColor: theme.payroll.greenLight,
        }
    },
    toolbar: {
        color: theme.payroll.greenMain,
        "& .MuiTab-textColorInherit":{
            color: theme.palette.secondary.mainGray,
        },
        '& .Mui-selected':{
            color: theme.palette.primary.black,
            fontWeight: 500
        },
        '& .MuiTabs-indicator': {
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: theme.payroll.greenMain,
        },
    },
    toolbarItem: {
        textTransform: 'none',
        fontSize: '14px', 
    },
    tableContainer: {
        minHeight: '55vh',
        maxHeight: '65vh',
    },
    divTableAndAction:{
        display: 'flex',
        width: "100%",
        
    },
    divTable:{
        overflow: "auto",
    },
    tableRowHidde: {
        display: 'none'
    },
    tableRow: {
        height: "90px",
        display: 'flex',
        padding: '0'
    },
    tableHeadTitle: {
        display: 'flex !important',
        justifyContent: 'start',
        fontFamily: 'Inter',
        fontWeight: 700,
        alignItems: "center !important",
        fontSize: "14px",
        color:'#252A31',
        width: '200px !important',
    },
    tableCellRow: {
        fontFamily: 'Inter',
        fontWeight: 400,
        textAlign: "start !important",
        fontSize: "14px",
        height: '53px',
        display: 'flex',
        alignItems: 'center',
        width: '200px !important',
    },
    containerIcons:{
        display: 'flex',
        gap: '15px',
        justifyContent: 'center',
        alignItems: 'center',
        height: '53px',
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
    },
    icons:{ },
    iconMessageAndEdit:{
        margin:0,
        color: theme.payroll.greenMain,
        width: '20px'
    },
    contaierPagination:{
        width: '100%',
        display:'flex',
        justifyContent: 'end',
        marginTop: '20px'
    },
    tableHeadTitleYTD: {
        color: theme.palette.primary.black,
        textAlign: "center !important",
        fontSize: "1rem",
        fontWeight: 700,
        "&:hover": {
            color: theme.palette.primary.black,
        },
        [theme.breakpoints.down('md')]: {
            fontSize: "0.8rem",
        }
    },
    tableCell: {
        color: theme.palette.secondary.black,
        fontSize: "0.8rem",
        textAlign: 'center',
        [theme.breakpoints.down('md')]: {
            fontSize: "0.7rem",
        }
    },
    tableGrid: {
        height: '58vh',
        width: '100%',
        border: 'none',
        overflowX: "hidden !important",
        '& .MuiDataGrid-columnSeparator': {
          display: 'none',
        },
        '& .MuiDataGrid-columnHeadersInner': {
            fontSize: '14px',
            height: "90px",
            display: 'flex',
            flexWrap: 'wrap',
            '& .MuiDataGrid-columnHeader': {
                padding: '0',
            },
            '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: '700',
                paddingLeft: '32px',
                color: theme.palette.primary.black,
            },
        },
        '& .MuiDataGrid-row': {
            fontSize: '14px',
            color: theme.palette.secondary.black,
        },
        '& .MuiDataGrid-cell': {
          display: 'flex',
          alignItems: 'center',
          lineHeight: '30px',
        },
        '& .MuiDataGrid-virtualScroller': {
          '::-webkit-scrollbar': {
            width: '8px',
            height: '8px', 
          },
          '::-webkit-scrollbar-track': {
            background: '#f1f1f1',
          },
          '::-webkit-scrollbar-thumb': {
            background: 'rgba(113, 113, 113, 0.5)',
          },
        },
    },
})

export const DialogFilterPayroll = () => ({
    dialog:{
        '& .MuiDialog-paper': {
            width: '350px',
            backgroundColor: theme.palette.primary.white,
            minHeight: '450px',
            padding: '24px',
            borderRadius: '9px'
        },
    },
    title:{
        margin: '0 0 20px 0',
        color: theme.palette.primary.black,
        fontFamily: 'Inter',
        fontWeight: 700,
        fontSize: '16px'
    },
    body: {
        minHeight: '400px',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column'
    },
    form: {
        flex: 1
    },
    marginDown:{
        marginBottom: '15px'
    },
    divActions: {
        height: {xs: 'auto', md: '50px'},
        gap: '20px',
        display: 'flex',
        flexDirection: {xs: 'column', sm: 'row'},
        justifyContent: 'end',
        marginBottom: '5px'
    },
    buttonCancel:{
        display: 'flex',
        height: '32px',
        padding: '8px 12px',
        backgroundColor: theme.button.bgColorGray,
        color: theme.palette.primary.black,
        borderRadius: '3px',
        fontFamily: 'Inter',
        fontWeight: 500,
        fontSize: '12px',
        textTransform: 'none',
        "&:hover":{
            backgroundColor: theme.button.bgColorGrayHover,
        }
    },
    buttonApply:{
        display: 'flex',
        height: '32px',
        padding: '8px 12px',
        backgroundColor: theme.payroll.greenMain,
        color: theme.palette.primary.white,
        borderRadius: '3px',
        fontFamily: 'Inter',
        fontWeight: 500,
        fontSize: '12px',
        textTransform: 'none',
        "&:hover":{
            backgroundColor: theme.payroll.greenMain,
        }
    },
    fieldsInput:{
        marginTop: '10px',
        width: '100%',
        '& .MuiTextField-root':{
            borderRadius:'3px',
            height: 22,
            border: `1px solid ${theme.palette.secondary.mediumGray}`,
        },
        '& .MuiInputBase-input':{
            borderRadius:'3px',
            height: 22,
            border: `1px solid ${theme.palette.secondary.mediumGray}`,
        },
        '.MuiSelect-outlined':{
            height: 22,
        }
    },
    label:{
        margin: 0,
        width: '100%',
        color: theme.palette.primary.black,
        fontFamily: 'Inter',
        fontWeight:500,
        fontSize: '14px'
    },
    menuItem: {
       
    },
    formGroup:{
        display: 'flex'
    },
    checkBox:{
        color: theme.palette.secondary.mainGray,
        '& .MuiSvgIcon-root': {
            fontSize: '20px',
          },
    },
    textSelect:{
        
        '& .MuiListItemText-root':{
            fontSize:'43px',
            
        },
        '.MuiListItemText-primary':{
            fontSize:'13px',
            fontFamily: 'Inter',
            fontWeight:400,
            color: theme.palette.primary.black,
        }
    },
    to:{
       margin:0,
       height:'32px',
       color: theme.palette.primary.black,
       fontFamily: 'Inter',
       fontWeight: 400,
       fontSize: '14px',
       display: 'flex',
       justifyContent: 'center',
       alignItems: 'center',
    },
    labelCheckbox:{
        '& .MuiFormControlLabel-label':{
            color: theme.palette.primary.black,
            fontFamily: 'Inter',
            fontWeight: 500,
            fontSize: '14px'
        }
    },
    radio:{
        color: theme.palette.secondary.mainGray,
    },
    datePicker:{
        '& .MuiCalendarPicker-root': {
            backgroundColor: 'blue',
            height: 50
        }
    },
    otherValuesForGroups:{
        color: theme.payroll.greenMain,
    },
    containerFilterCompany: {
        padding: '10px 30px',
    }
})

export const NotesPayrollStyle = () => ({
    containerNotes: {
        backgroundColor: theme.palette.primary.white,
        width: {xs: '80%', md: '250px', lg: '250px'},
        minHeight: '180px',
        display: 'flex',
        flexDirection: 'column',
        padding: '20px'
    },
    title:{
        color: theme.palette.primary.black,
        fontFamily: 'Inter',
        fontWeight: 500,
        fontSize:'14px',
        margin: 0
    },
    textTarea:{
        border: `1px solid ${theme.palette.secondary.mediumGray}`,
        borderRadius: '3px',
        marginTop: '10px',
        fontFamily: 'Inter',
        fontWeight: 400,
        fontSize: '14px',
        color: theme.palette.secondary.mainGray,
        padding: 10,
        '&:active':{
            border: `1px solid ${theme.palette.secondary.mediumGray}`,
            backgroundColor: 'aqua'
        }
    }
})

export const EditPayrollStyle = () => ({
    dialogEdit:{
        '& .MuiDialog-paper': {
            width: '100%',
            backgroundColor: theme.palette.primary.white,
            minHeight: '350px',
            padding: '24px',
            borderRadius: '9px',
            boxSizing: 'border-box !important',
            overflow: 'hidden'
        },
    },
    body:{
        width: '100%',
        boxSizing: 'border-box !important',
        overflow: 'auto',
    },
    title:{
        color: theme.palette.primary.black,
        fontFamily: 'Inter',
        fontWeight: 700,
        fontSize: '16px',
        margin: '0 0 10px 0'
    },
    table:{
        overflow: 'auto',
        minHeight: '150px',
    },
    tableRowEdit: {
        minHeight: "40px", 
        display: 'flex',
        minWidth: '100%'
    },
    tableHeadTitleEdit: {
        display: 'flex !important',
        fontFamily: 'Inter',
        fontWeight: 600,
        fontSize: "14px",
        color: theme.palette.primary.black,
        minWidth: '200px !important',
    },
    tableCellRow: {
        fontFamily: 'Inter',
        display: 'flex',
        alignItems: 'center',
        fontWeight: 400,
        textAlign: "start !important",
        fontSize: "13px",
        width: '100%',
        color: theme.palette.secondary.black,
    },
    containerFormsHoursAndWage:{
        width:'100%',
        overflowX: {xs: 'scroll', md: 'hidden', lg: 'hidden'}
    },
    formsHoursAndWage:{
        width:'100%',
    },
    containerNameMonth:{
        display: {xs:'none', sm: 'none', md: 'flex'},
        margin: '25px 0 0 0',
    },
    nameMonth:{
        width: '100%',
        boxSizing: 'border-box',
    },
    month: {
        display: 'block !important',
        width: '100% !important',
        color: theme.palette.primary.black,   
        fontWeight: 600,
        fontFamily: 'Inter',
        fontSize: '14px',
    },
    monthSx: {
        display: {xs: 'block', md: 'none'},
        width: '100% !important',
        color: theme.palette.primary.black,
        fontWeight: 500,
        fontFamily: 'Inter',
        fontSize: '12px',
        margin: '0 0 0 8px'
    },
    hourWage:{
        display:'flex',
        width: {xs: '100%', md:'80px !important'},
        color: theme.palette.primary.black,
        fontFamily: 'Inter',
        fontWeight: 600,
        fontSize: '14px',
        justifyContent: {xs: 'center', md:'end'},
        alignItems: 'center',
        padding: '0 10px 0 0',
        marginBottom: {xs: '10px', md: '0'}
    },
    fieldsInput:{
        fontSize: '13px',
        fontWeight: 400,
        fontFamily: 'Inter',
        width: '100%',
        color: theme.palette.secondary.black,
        '& .MuiTextField-root':{
            borderRadius:'3px',
            height: 12,
            border: '1px solid #BAC7D5',
        },
        '.MuiSelect-outlined':{
            height: 22,
            width: '100px',
        }
    },
    containerForms:{
        display:'flex',
        margin: '0px 0 0 0 ',
    },
    containerFormHours:{
        display:'flex',
        margin:0,
        justifyContent: 'start'
    },
    spacingItemForm:{
        padding: '0 10px 0 0'
    },
    divider: {
        width: '100%',
        color: theme.palette.secondary.mediumGray,
        margin: '10px 0'
    },
    containerSelect: {
        marginTop: '20px',
        display: 'flex',
        gap: '20px',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column'
        }
    },
    labelSelect: {
        color: theme.palette.primary.black,
        fontFamily: 'Inter',
        fontWeight: 500,
        fontSize: '16px'
    }
})

export const MenuExcelStyle = () => ({
    containerMenu:{
        '& .MuiMenu-paper':{
            backgroundColor: theme.palette.primary.white,
            borderRadius: '3px',
        }
    },
    menuItem:{
        margin:'0px 10px',
        '&.MuiMenuItem-root':{
            fontSize: '12px',
            fontFamily: 'Inter',
            fontWeight: 500,
            color: theme.palette.primary.black,
        },
        '&:hover':{
            borderRadius: '3px'
        }
    }
})

export const TableInvoiceStyle = () => ({
    table:{
        display: 'flex',
        flexDirection: 'column',
    },
    tableRow:{
        height: "60px",
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between'
    },
    tableHeadTitleInvoice: {
        display: 'flex !important',
        justifyContent: 'start',
        fontFamily: 'Inter',
        fontWeight: 700,
        alignItems: "center !important",
        fontSize: "14px",
        color: theme.palette.primary.black,
        width: '100%'
    },
    tableCellRow: {
        fontFamily: 'Inter',
        fontWeight: 400,
        textAlign: "start !important",
        fontSize: "14px",
        flex: 10,
        height: '53px'
    },
    tableGrid: {
        minHeight: 500,
        fontSize: '14px',
        width: '100%',
        display: 'flex',
        '& .MuiDataGrid-columnSeparator': {
          display: 'none',
        },
        '& .MuiDataGrid-columnHeadersInner': {
          fontSize: '14px',
          [theme.breakpoints.down('md')]: {
            fontSize: '14px',
          },
          '& .MuiDataGrid-columnHeader': {
            padding: '0',
          },
          '& .MuiDataGrid-columnHeaderTitle': {
            fontWeight: 700,
            paddingLeft: '22px',
            color: theme.palette.primary.black,
            fontFamily: 'Inter'
          },
        },
        '& .MuiDataGrid-row': {
          fontSize: '14px',
          paddingLeft: '15px',
          fontFamily: 'Inter',
          color: theme.palette.secondary.black,
          fontWeight: 400,
          [theme.breakpoints.down('md')]: {
            fontSize: '14px',
          },
        },
        '& .MuiDataGrid-cell': {
          display: 'flex',
          alignItems: 'center',
          lineHeight: '30px',
        },
        '& .MuiDataGrid-virtualScroller': {
          '::-webkit-scrollbar': {
            width: '10px',
          },
          '::-webkit-scrollbar-track': {
            background: '#f1f1f1',
          },
          '::-webkit-scrollbar-thumb': {
            background: 'rgba(16, 16, 16, 0.5)',
          },
          '::-webkit-scrollbar-thumb:hover': {
            background: '#555',
          },
        },
        '& 	.MuiDataGrid-checkboxInput': {
          '& .MuiSvgIcon-root': {
            fontSize: '14px',
            [theme.breakpoints.down('md')]: {
              fontSize: '12px',
            },
          },
        },
        '& .MuiDataGrid-sortIcon':{
            color: '#0172CB',
        }
    },
    link: {
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    tableHeadTitle: {
        textAlign: "start !important",
        fontSize: "0.9rem",
        fontWeight: 700,
    },
    containerTitle: {
        display: 'flex',
        justifyContent:'space-between',
        [theme.breakpoints.down('sm')]: {
           flexDirection: 'column',
           gap: '20px',
           alignItems: 'center'
        },
    },
})

export const DateFilterStyle = () => ({
    label: {
        margin: 0,
        width: '100%',
        color: theme.palette.primary.black,
        fontFamily: 'Inter',
        fontWeight:500,
        fontSize: '14px'
    },
    to: {
        textAlign: 'center',
        fontWeight: 500,
        color: '#6B7280',
        paddingTop: '8px'
    },
    toggleGroup: {
        gap: '4px',
    },
    toggleBtn: {
        borderRadius: '6px !important',
        border: '1px solid #D1D5DB !important',
        textTransform: 'none',
        fontSize: '0.95rem',       
        padding: '3px 10px',       
        minWidth: 'unset',
        lineHeight: 1.5,
        '&.Mui-selected': {
        backgroundColor: '#1976d2',
        color: '#fff',
        '&:hover': { backgroundColor: '#1565c0' }
        }
    },
    fieldsInput:{
        marginTop: '10px',
        width: '100%',
        '& .MuiTextField-root':{
            borderRadius:'3px',
            height: 22,
            border: `1px solid ${theme.palette.secondary.mediumGray}`,
        },
        '& .MuiInputBase-input':{
            borderRadius:'3px',
            height: 22,
            border: `1px solid ${theme.palette.secondary.mediumGray}`,
        },
        '.MuiSelect-outlined':{
            height: 22,
        }
    },
    menuItem:{
        margin:'0px 10px',
        '&.MuiMenuItem-root':{
            fontSize: '12px',
            fontFamily: 'Inter',
            fontWeight: 500,
            color: theme.palette.primary.black,
        },
        '&:hover':{
            borderRadius: '3px'
        }
    }
})

export const DialogNewTargetStyle = () => ({
  dialog: {
    '& .MuiDialog-paper': {
      width: '100%',
      backgroundColor: theme.palette.primary.white,
      minHeight: '400px',
      padding: '24px',
      borderRadius: '9px',
      boxSizing: 'border-box',
    },
  },
  title: {
    color: theme.palette.primary.black,
    fontFamily: 'Inter',
    fontWeight: 700,
    fontSize: '22px',
    margin: '0 0 0 0',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    paddingTop: '10px !important',
    overflowY: 'visible', 
  },
  fieldInput: {
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: '14px',
    '& .MuiOutlinedInput-root': {
        borderRadius: '3px',
        '& fieldset': {
        borderColor: theme.palette.secondary.mediumGray,
        },
        '&:hover fieldset': {
        borderColor: theme.payroll.greenMain,
        },
        '&.Mui-focused fieldset': {
        borderColor: theme.payroll.greenMain,
        borderWidth: '1px',
        },
        '&.Mui-error fieldset': {
        borderColor: theme.palette.error.main,
        },
    },
    '& .MuiInputLabel-root': {
        fontFamily: 'Inter',
        fontWeight: 400,
        fontSize: '14px',
        color: theme.palette.secondary.mainGray,  
        '&.Mui-focused': {
        color: theme.payroll.greenMain,          
        },
        '&.Mui-error': {
        color: theme.palette.error.main,         
        },
    },
    '& .MuiInputBase-input': {
        fontFamily: 'Inter',
        fontSize: '14px',
        color: theme.palette.primary.black,
    },
    },
  divActions: {
    display: 'flex',
    justifyContent: 'end',
    gap: '12px',
    padding: '16px 0 0 0',
  },
  buttonCancel: {
    display: 'flex',
    height: '32px',
    padding: '8px 12px',
    backgroundColor: theme.button.bgColorGray,
    color: theme.palette.primary.black,
    borderRadius: '3px',
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: '12px',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: theme.button.bgColorGrayHover,
    },
  },
  buttonSave: {
    display: 'flex',
    height: '32px',
    padding: '8px 12px',
    backgroundColor: theme.payroll.greenMain,
    color: theme.palette.primary.white,
    borderRadius: '3px',
    fontFamily: 'Inter',
    fontWeight: 500,
    fontSize: '12px',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: theme.payroll.greenMain,
    },
    '&.Mui-disabled': {
      backgroundColor: theme.palette.secondary.mediumGray,
      color: theme.palette.primary.white,
    },
  },
})
